/**
 * Estrutura auxiliar o acesso às permissões pelo nome da funcionalidade
 */
const funcionalidades = {
  livroFiscal: {
    consultar: "EFIS LIVRO FISCAL CONSULTAR",
    deletar: "EFIS LIVRO FISCAL DELETAR",
    inserir: "EFIS LIVRO FISCAL INSERIR",
    alterar: "EFIS LIVRO FISCAL ALTERAR",
  },
  procedimentoFiscal: {
    consultar: "EFIS PROCEDIMENTO FISCAL CONSULTAR",
    deletar: "EFIS PROCEDIMENTO FISCAL DELETAR",
    inserir: "EFIS PROCEDIMENTO FISCAL INSERIR",
    alterar: "EFIS PROCEDIMENTO FISCAL ALTERAR",
  },
  os: {
    executarDetalhe: "EFIS OS EXECUTAR DETALHE",
    consultaDadosAtividades: "EFIS OS ATIVIDADES",
    executar: "EFIS OS EXECUTAR",
    executarDiretor: "EFIS OS DIRETOR EXECUTAR",
    prorrogarOs: "EFIS OS DIRETOR PRORROGAR",
    atribuirOs: "EFIS OS DIRETOR ATRIBUIR",
    cancelarOs: "EFIS OS DIRETOR CANCELAR",
    consultaDadosOcorrencias: "EFIS OS OCORRENCIAS",
    consultaDadosAnexos: "EFIS OS ANEXO",
    detalhes: "EFIS OS EXECUTAR DETALHE",
    ProrrogacaoAndamento: "EFIS PRORROGACAO ANDAMENTO",
    ProrrogacaoConsultar: "EFIS PRORROGACAO CONSULTAR",
    visaoGerencial: "EFIS OS VISAO GERENCIAL",
    visaoAuditor: "EFIS OS VISAO AUDITOR",
    planilhaGerar: "EFIS OS PLANILHA GERAR",
  },
  spf: {
    consultar: "EFIS SPF CONSULTAR",
    homologar: "EFIS SPF HOMOLOGAR",
    inserir: "EFIS SPF INSERIR",
    revisar: "EFIS SPF REVISAR",
    cancelar: "EFIS SPF CANCELAR",
    download: "EFIS SPF DOWNLOAD",
    alterar: "EFIS SPF ALTERAR",
  },
  ciclo: {
    consultar: "EFIS CICLO ACAO CONSULTAR",
    deletar: "EFIS CICLO ACAO DELETAR",
    inserir: "EFIS CICLO ACAO INSERIR",
    alterar: "EFIS CICLO ACAO ALTERAR",
  },
  tipoAcaoFiscal: {
    consultar: "EFIS TIPO ACAO FISCAL CONSULTAR",
    deletar: "EFIS TIPO ACAO FISCAL DELETAR",
    inserir: "EFIS TIPO ACAO FISCAL INSERIR",
    alterar: "EFIS TIPO ACAO FISCAL ALTERAR",
  },
  textoPadrao: {
    consultar: "EFIS TEXTO PADRAO CONSULTAR",
    deletar: "EFIS TEXTO PADRAO DELETAR",
    inserir: "EFIS TEXTO PADRAO INSERIR",
    alterar: "EFIS TEXTO PADRAO ALTERAR",
  },
  fase: {
    consultar: "EFIS FASE CONSULTAR",
    deletar: "EFIS FASE DELETAR",
    inserir: "EFIS FASE INSERIR",
    alterar: "EFIS FASE ALTERAR",
  },
  ordemservico: {
    inserir: "EFIS OS INSERIR",
    consultar: "EFIS OS CONSULTAR",
    tomarCiencia: "EFIS OS AUDITOR TOMAR CIENCIA",
    alterarExecutorConsultar: "EFIS ALTER EXECUTOR CONSULTAR",
    alterarExecutorInserir: "EFIS ALTER EXECUTOR INSERIR",
    inserirAltExecutor: "EFIS ALTER EXECUTOR INSERIR",
    deletarAltExecutor: "EFIS ALTER EXECUTOR INSERIR",
    tsps: "EFIS TSPS",
  },
  atividadePadrao: {
    consultar: "EFIS ATIVIDADE PADRAO CONSULTAR",
    deletar: "EFIS ATIVIDADE PADRAO DELETAR",
    inserir: "EFIS ATIVIDADE PADRAO INSERIR",
    alterar: "EFIS ATIVIDADE PADRAO ALTERAR",
  },
  roteiro: {
    consultar: "EFIS ROTEIRO CONSULTAR",
    deletar: "EFIS ROTEIRO DELETAR",
    inserir: "EFIS ROTEIRO INSERIR",
    alterar: "EFIS ROTEIRO ALTERAR",
  },
  tipoDivergencia: {
    consultar: "EFIS TIPO DIVERGENCIA CONSULTAR",
    deletar: "EFIS TIPO DIVERGENCIA DELETAR",
    inserir: "EFIS TIPO DIVERGENCIA INSERIR",
    alterar: "EFIS TIPO DIVERGENCIA ALTERAR",
  },
  tipoOcorrencia: {
    consultar: "EFIS TIPO OCORRENCIA CONSULTAR",
    deletar: "EFIS TIPO OCORRENCIA DELETAR",
    inserir: "EFIS TIPO OCORRENCIA INSERIR",
    alterar: "EFIS TIPO OCORRENCIA ALTERAR",
  },
  tipoParteServico: {
    consultar: "EFIS TIPO PARTE SERVICO CONSULTAR",
    deletar: "EFIS TIPO PARTE SERVICO DELETAR",
    inserir: "EFIS TIPO PARTE SERVICO INSERIR",
    alterar: "EFIS TIPO PARTE SERVICO ALTERAR",
  },
  modeloImportacao: {
    consultar: "EFIS MODELO IMPORTACAO CONSULTAR",
    deletar: "EFIS MODELO IMPORTACAO DELETAR",
    inserir: "EFIS MODELO IMPORTACAO INSERIR",
    alterar: "EFIS MODELO IMPORTACAO ALTERAR",
  },
  textoTipoParteServico: {
    consultar: "EFIS TEXTO PARTE SERVICO CONSULTAR",
    deletar: "EFIS TEXTO PARTE SERVICO DELETAR",
    inserir: "EFIS TEXTO PARTE SERVICO INSERIR",
    alterar: "EFIS TEXTO PARTE SERVICO ALTERAR",
  },
  tipoInaptidao: {
    consultar: "EFIS TIPO INAPTIDAO CONSULTAR",
    deletar: "EFIS TIPO INAPTIDAO DELETAR",
    inserir: "EFIS TIPO INAPTIDAO INSERIR",
    alterar: "EFIS TIPO INAPTIDAO ALTERAR",
  },
  ocorrencia: {
    inserir: "EFIS OS OCORRENCIAS",
    consultaDadosOcorrencias: "EFIS OS OCORRENCIAS",
  },
  parteServico: {
    consultar: "EFIS PARTE SERVICO CONSULTAR",
    deletar: "EFIS PARTE SERVICO DELETAR",
    inserir: "EFIS PARTE SERVICO INSERIR",
    alterar: "EFIS PARTE SERVICO ALTERAR",
    encerrar: "EFIS PARTE DE SERVICO ENCERRAR",
    auditor: "EFIS PARTE DE SERVICO V AUDITOR", // Listar apenas as partes de serviço com status A abertas pelo auditor logado
    adm: "EFIS PARTE DE SERVICO V ADM", // Listar as partes de serviço com status A do setor do auditor logado
    gerencial: "EFIS PARTE DE SERVICO V GERENCIAL", // Listar todas as partes de serviço com status A
  },
  expedienteAtipico: {
    consultar: "EFIS PONTO FACULTATIVO CONSULTAR",
    deletar: "EFIS PONTO FACULTATIVO DELETAR",
    inserir: "EFIS PONTO FACULTATIVO INSERIR",
    alterar: "EFIS PONTO FACULTATIVO ALTERAR",
  },
  extratoFiscal: { consultar: "EFIS OS EXECUTAR" },
  autoInfracaoEspecial: { consultar: "EFIS AI ESP CONSULTAR", inserir: "EFIS AI ESP INSERIR" },
};

export default funcionalidades;
